import React, { Component } from 'react';
import FocusTrap from "focus-trap-react";
import Modal from 'react-awesome-modal';
import ReactDom from 'react-dom';
import classess from './MfaModal.scss';
class MfaModal extends Component {
    constructor(props) {
        super(props);
        this.modalRoot = document.createElement('div');
        this.modalRoot.id = 'mfa-modal';
    }

    componentDidMount(){
        document.body.appendChild(this.modalRoot);
        document.body.style.overflow = 'hidden';
    }
    componentWillUnmount(){
        document.body.removeChild(this.modalRoot);
        document.body.style.overflow = '';
    }
    render() {
        if (!this.props.isOpen) {
            return null;
        }
        return ReactDom.createPortal(
            <FocusTrap>
                <Modal visible>
                    <div className={classess.mfaModalContent}>{this.props.children}</div>
                </Modal>
            </FocusTrap>, this.modalRoot
        );

    }
}

export default MfaModal;
